const FORBIDDEN_CONTROL_CHARS_RE = /[\n\r\t]/g;
const FIVE_OR_MORE_SPACES_RE = / {5,}/g;

export function sanitizeWhatsAppTemplateParamText(text: string): string {
  return text
    .replace(FORBIDDEN_CONTROL_CHARS_RE, "")
    .replace(FIVE_OR_MORE_SPACES_RE, "    ");
}
